import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../../widgets/button";
import ConfirmationPopup from "../../../widgets/confirmationPopup";
interface Props {
  data: any;
  context: any;
}

const EditRow: React.FunctionComponent<Props> = (props) => {
  const history = useHistory();
  const [modal, setModal] = useState<boolean>(false);

  const onViewButtonClicked = (id: string) => {
    history.push(`/area-settings/${id}`);
  };

  const onEditButtonClicked = () => {
    props.context.componentParent.onEditButtonClicked(props.data);
  };

  return (
    <>
      <ConfirmationPopup
        message={`Are you sure to Delete?`}
        isOpen={modal}
        confirmedEvent={() => {
          props.context.componentParent.onChangeStatusToDelete(props.data);
          setModal(!modal);
        }}
        toggle={() => {
          setModal(!modal);
        }}
      ></ConfirmationPopup>
      <Button
        label="View Areas"
        className="ml-2 btn btn-outline-secondary"
        onClick={() => onViewButtonClicked(props.data.id)}
      />

      <button
        className="Action_btn"
        title="Edit"
        style={{ marginLeft: "16px" }}
        onClick={() => onEditButtonClicked()}
      >
        <i className="bi bi-pencil-square"></i>
      </button>

      <button
        className="Action_btn"
        title="Delete"
        style={{ marginLeft: "16px" }}
        onClick={() => {
          setModal(!modal);
        }}
      >
        <i className="bi bi-trash"></i>
      </button>
    </>
  );
};

EditRow.defaultProps = {};

export default EditRow;
